import { render } from "./UnsavedChangesModal.vue?vue&type=template&id=50bf74b0"
import script from "./UnsavedChangesModal.vue?vue&type=script&lang=js"
export * from "./UnsavedChangesModal.vue?vue&type=script&lang=js"

import "./UnsavedChangesModal.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__